export const LEADERBOARD_INFO = 'LEADERBOARD_INFO';
export const GET_LEADERBOARD_PENDING = 'GET_LEADERBOARD_PENDING';
